import { useContext, useState } from "react"
import SelectPropertyView from "./SelectPropertyView"
import EditPropertyContext from "./EditPropertyContext"
import PropertyInfoForm from "./PropertyInfoForm"
import { Skeleton } from "antd"
import HeroContainer from "../common/HeroContainer"
import { useCustomerQuery } from "../customers/customerQueries"
import HeroButtonsContainer from "../common/HeroButtonsContainer"
import HeroButton from "../common/HeroButton"
import { faCloudArrowUp, faImage, faLocationDot, faPaperclip, faSave } from "@fortawesome/pro-solid-svg-icons"
import { getLocation, isValidForSave } from "./propertyModel"
import { useSavePropertyMutation } from "./propertyQueries"
import AttachmentUpload from "../attachments/AttachmentUpload"
import PropertyPhotoModal from "./PropertyPhotoModal"
import DeleteRestoreProperty from "./DeleteRestoreProperty"

const PropertyDetailView = () => {
  const { customerId, selectedPropertyId, property, propertyIsLoading, hasChanges, editState, dispatch, selectProperty, showDeletedView } = useContext(EditPropertyContext)
  const customerQuery = useCustomerQuery(customerId!)
  const saveMutation = useSavePropertyMutation(propertyId => selectProperty(propertyId, true))
  const [isAttachmentUploadOpen, setIsAttachmentUploadOpen] = useState(false)
  const [isPhotoModalOpen, setIsPhotoModalOpen] = useState(false)

  const saveDisabled = !hasChanges || !isValidForSave(editState)
  const location = getLocation(editState)

  return <div id="main" className="main-template has-elements fluid-container">
    {selectedPropertyId === undefined && <SelectPropertyView />}
    {selectedPropertyId !== undefined && <div>
      <HeroContainer imgSrc={property?.primaryPhotoUrl ?? ''} />
      <div className="hero-details">
        <h1>
            {property?.displayName}
            <small>{customerQuery.data?.displayName}</small>
        </h1>
        {!showDeletedView && <HeroButtonsContainer>
          <HeroButton color="yellow" icon={faLocationDot} disabled={location === undefined} onClick={() => {
            window.open("https://www.google.com/maps/dir/?api=1&destination=" + location?.latitude + "," + location?.longitude + "&travelmode=driving", "_blank");
          }}/>
          <HeroButton color="blue" icon={faImage} onClick={() => setIsPhotoModalOpen(true)}/>
          <HeroButton color="blue" icon={faPaperclip} number={property?.attachments} disabled={selectedPropertyId === undefined} onClick={() => {
            window.location.href = `#!/customers/${customerId}/properties/${selectedPropertyId}/attachments#this-property`
          }}/>
          <HeroButton color="blue" icon={faCloudArrowUp} disabled={selectedPropertyId === undefined} onClick={() => setIsAttachmentUploadOpen(true)} />
          <HeroButton icon={faSave} disabled={saveDisabled} onClick={() => {
            saveMutation.mutate({customerId: customerId!, property: editState})
          }} />
        </HeroButtonsContainer>}
      </div>

      { propertyIsLoading && <>
        <section><Skeleton active paragraph={{rows: 8}} /></section>
        <section><Skeleton active paragraph={{rows: 4}} /></section>
      </>}
      { !propertyIsLoading && <>
        <PropertyInfoForm />
        {(selectedPropertyId !== 0) && <DeleteRestoreProperty />}
      </> }
    </div>}

    <AttachmentUpload
      isOpen={isAttachmentUploadOpen}
      customerId={customerId!}
      propertyId={selectedPropertyId}
      defaultFolder={"This Property"}
      onClose={() => setIsAttachmentUploadOpen(false)}
    />

    <PropertyPhotoModal
      isOpen={isPhotoModalOpen}
      customerId={customerId!}
      propertyId={property?.id ?? 0}
      priorSelectedAttachmentId={property?.primaryPhotoId}
      onCancel={() => setIsPhotoModalOpen(false)}
      onSelect={attachmentId => {
        dispatch({type: 'photoChanged', primaryPhotoId: attachmentId})
        setIsPhotoModalOpen(false)
      }}
      onClear={() => {
        dispatch({type: 'photoChanged', primaryPhotoId: null})
        setIsPhotoModalOpen(false)
      }}
    />
  </div>
}

export default PropertyDetailView